import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
import { WHATSAPP_URL } from './config';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'py-4' : 'py-6'}`} data-id="element-141">
      <div className="max-w-7xl mx-auto px-6" data-id="element-142">
        <div className={`flex items-center justify-between rounded-full transition-all duration-300 ${scrolled ? 'bg-white/70 backdrop-blur-xl border border-white/40 shadow-glass px-6 py-3' : 'bg-transparent px-2'}`} data-id="element-143">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-144">
            <div className="w-10 h-10 rounded-xl bg-nova-dark flex items-center justify-center text-nova-cyan group-hover:rotate-12 transition-transform duration-300" data-id="element-145">
              <SparklesIcon size={20} data-id="element-146" />
            </div>
            <span className="font-black text-xl tracking-tight text-nova-dark" data-id="element-147">
              NOVA
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-148">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-nova-gray hover:text-nova-cyan transition-colors" data-id="element-149">
                {link.name}
              </a>)}
          </div>

          {/* CTA */}
          <div className="hidden md:block" data-id="element-150">
            <Button href={WHATSAPP_URL} variant="primary" className="!py-2.5 !px-6 text-sm" data-id="element-151">
              Reservar Turno
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-nova-dark" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-152">
            {mobileMenuOpen ? <XIcon data-id="element-153" /> : <MenuIcon data-id="element-154" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-4 right-4 mt-2 p-6 glass-panel flex flex-col gap-4" data-id="element-155">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-nova-dark py-2 border-b border-nova-gray/10" data-id="element-156">
              {link.name}
            </a>)}
          <Button href={WHATSAPP_URL} variant="primary" className="w-full mt-4" data-id="element-157">
            Reservar Turno
          </Button>
        </div>}
    </motion.nav>;
}